import { EventsBySportIdRequest } from "../../dependencies";
export var getMarketEventID = function (e, m) {
    return e.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString()
        ? "0"
        : m.eventId || "0";
};
//# sourceMappingURL=getMarketEventID.js.map